import "core-js/modules/es.array.concat.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Throttler = /*#__PURE__*/function () {
  function Throttler(target, func, delayMs) {
    _classCallCheck(this, Throttler);

    _defineProperty(this, "target", void 0);

    _defineProperty(this, "func", void 0);

    _defineProperty(this, "delayMs", void 0);

    _defineProperty(this, "timerId", void 0);

    _defineProperty(this, "args", void 0);

    this.target = target;
    this.func = func;
    this.delayMs = delayMs;
    this.timerId = null;
    this.args = null;
  }

  _createClass(Throttler, [{
    key: "normalCall",
    value: function normalCall() {
      var _this = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.args = args;

      if (this.timerId === null) {
        this.$invoke();
        this.timerId = setTimeout(function () {
          var _this$normalCall;

          // IE8 doesn't reliably clear timeout, so this additional
          // check is needed
          if (_this.timerId === null) return;

          _this.$clearTimer();

          if (args.length > 0) (_this$normalCall = _this.normalCall).apply.apply(_this$normalCall, [_this].concat(args));
        }, this.delayMs);
      }
    }
  }, {
    key: "immediateCall",
    value: function immediateCall() {
      this.$clearTimer();

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.args = args;
      this.$invoke();
    }
  }, {
    key: "isPending",
    value: function isPending() {
      return this.timerId !== null;
    }
  }, {
    key: "$clearTimer",
    value: function $clearTimer() {
      if (this.timerId !== null) {
        clearTimeout(this.timerId);
        this.timerId = null;
      }
    }
  }, {
    key: "$invoke",
    value: function $invoke() {
      this.func.apply(this.target, this.args);
      this.args = null;
    }
  }]);

  return Throttler;
}(); // Returns a throttled version of the given function.
// Throttling means that the underlying function will
// be executed no more than once every `threshold`
// milliseconds.
//
// For example, if a function is throttled with a
// threshold of 1000ms, then calling it 17 times at
// 900ms intervals will result in something like 15
// or 16 executions of the underlying function.
// eslint-disable-next-line no-unused-vars


function throttle(threshold, func) {
  var executionPending = false;
  var timerId = null;
  var self, args;

  function throttled() {
    self = null;
    args = null;

    for (var _len3 = arguments.length, argumentVals = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      argumentVals[_key3] = arguments[_key3];
    }

    if (timerId === null) {
      // Haven't seen a call recently. Execute now and
      // start a timer to buffer any subsequent calls.
      timerId = setTimeout(function () {
        // When time expires, clear the timer; and if
        // there has been a call in the meantime, repeat.
        timerId = null;

        if (executionPending) {
          executionPending = false;
          throttled.apply(self, args);
        }
      }, threshold);
      func.apply(this, argumentVals);
    } else {
      // Something executed recently. Don't do anything
      // except set up target/arguments to be called later
      executionPending = true;
      self = this;
      args = argumentVals;
    }
  }

  return throttled;
}

export { Throttler, throttle };